import type { SelectOption } from '@/components/ui/select'
import { DEFAULT_STATE_COUNTRY, STATES_BY_COUNTRY, StateCountry } from '@/constants/states'

const resolveStates = (country?: string | null) =>
  STATES_BY_COUNTRY[(country?.toUpperCase() as StateCountry) ?? DEFAULT_STATE_COUNTRY] ??
  STATES_BY_COUNTRY[DEFAULT_STATE_COUNTRY]

// Note: `state` is a free string on the backend, so a stored value that is not a known code
// (e.g. "Illinois", "il") is kept as an extra option instead of being dropped on the next save
export const getStateOptions = (
  country?: string | null,
  current?: string | null,
): SelectOption<string>[] => {
  const states = resolveStates(country)
  const options = states.map(({ code, name }) => ({ label: `${name} (${code})`, value: code }))

  return current && !states.some(({ code }) => code === current)
    ? [{ label: current, value: current }, ...options]
    : options
}

export const getStateLabel = (country?: string | null, code?: string | null) => {
  if (!code) return ''

  const state = resolveStates(country).find((item) => item.code === code)
  return state ? `${state.name} (${state.code})` : code
}
